var _filter, _use, _use2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96 96",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.05,
      stroke: "none"
    },
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.07,
      stroke: "none"
    },
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "scale(.55814)",
    r: 85.534,
    fy: 9.345,
    fx: 62.97,
    cy: 9.345,
    cx: 62.97,
    gradientUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafb",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e4e7",
      stopOpacity: 1
    },
    offset: 0.523
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cdd1",
      stopOpacity: 1
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "scale(.55814)",
    y2: 192.95,
    x2: 178.178,
    y1: 74.626,
    x1: 19.838,
    gradientUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.242
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccc",
      stopOpacity: 1
    },
    offset: 1
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    height: "100%",
    width: "100%",
    y: "0%",
    x: "0%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M72.398 12H16c-2.2 0-4 1.8-4 4v64c0 2.2 1.8 4 4 4h64c2.2 0 4-1.8 4-4V23.602c0-1-.398-2-1.2-2.801l-7.6-7.602C74.397 12.4 73.397 12 72.397 12Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#799aa5",
      fillOpacity: 1,
      opacity: 1
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    mask: "url(#b)",
    xlinkHref: "#image1175299"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 38H26c-2.2 0-4-1.8-4-4V12h48v22c0 2.2-1.8 4-4 4Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#698a9b",
      fillOpacity: 1
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    mask: "url(#c)",
    xlinkHref: "#image1175302"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30 12v20c0 2.2 1.8 4 4 4h32c2.2 0 4-1.8 4-4V12Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 16h8v16h-8Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4e6874",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 76h4v4h-4Zm-60 0h4v4h-4Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#485c6c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 84H28c-2.2 0-4-1.8-4-4V56c0-2.2 1.8-4 4-4h40c2.2 0 4 1.8 4 4v24c0 2.2-1.8 4-4 4Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#e)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.5f43acde4b6585bd6b01919e787706e2.svg";
export { ForwardRef as ReactComponent };